import React from 'react';
import { Badge } from 'react-bootstrap';

const QscScoreBadge = ({ score }) => {
  const pct = parseFloat(score) || 0;
  let bg = 'danger';
  if (pct >= 80) bg = 'success';
  else if (pct >= 70) bg = 'warning';

  return (
    <Badge bg={bg} text={bg === 'warning' ? 'dark' : 'white'}>
      {pct.toFixed(1)}%
    </Badge>
  );
};

export default QscScoreBadge;
